import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { EventService } from "../../event-service/event.service";
import { NoticeService } from "../../models/notice.service";

@Component({
  selector: "ab-notice-list",
  templateUrl: "./notice-list.component.html",
})
export class NoticeListComponent implements OnInit {
  @Input() public group: any;
  @Input() public activeNotice: any;
  @Input() public activeFilters: any;
  @Input() public filters: any;

  public params: any;
  public totalPages: number;
  public pageSize: number;
  public loading: boolean;
  public notices: any;
  public totalItems: number;
  public pageStart: number;
  public pageEnd: number;
  public filtering: boolean;
  public highlights: any = {};

  constructor(
    private eventService: EventService,
    private noticeService: NoticeService,
  ) {}

  public ngOnInit() {
    this.pageSize = 50;
    this.totalPages = 0;

    this.params = {
      projectId: this.group.projectId,
      groupId: this.group.id,
      limit: this.pageSize,
      page: 1,
    };

    return this.fetchPage(1);
  }

  public hasNextPage = () => this.params.page < this.totalPages;
  public hasPreviousPage = () => this.params.page > 1 && this.totalPages > 1;
  public loadNextPage = () => this.fetchPage(this.params.page + 1);
  public loadPreviousPage = () => this.fetchPage(this.params.page - 1);
  public trackBy = (index: number, _notice: any) => index;

  public fetchPage(page: number) {
    this.loading = true;

    this.params.page = page;
    const paramFilters = this.filters || {};
    for (const key of Object.keys(paramFilters)) {
      if (paramFilters[key] != null) {
        this.params[key] = paramFilters[key];
      }
    }

    return this.noticeService
      .query(this.params)
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe((data: any) => {
        this.notices = data.notices;
        this.totalItems = data.count;
        this.totalPages = Math.ceil(this.totalItems / this.pageSize);

        // We're counting backwards
        this.pageStart =
          this.totalItems - (this.params.page - 1) * this.pageSize;
        this.pageEnd = Math.max(1, this.pageStart - this.pageSize + 1);

        if (this.totalItems < this.group.noticeCount && this.activeFilters) {
          this.filtering = true;
        }
      });
  }

  public toggleOccurrenceList() {
    this.eventService.publish("notice-view:toggleOccurrenceList");
  }
}
